import { defineMessages } from 'react-intl';
import type { BusinessExpertiseEnum } from '@foundershub/api-client';

export const businessExpertiseLabels = defineMessages<BusinessExpertiseEnum>({
  accessibility: {
    defaultMessage: 'Accessibility',
    description: 'business expertise category label',
  },
  b2b: {
    defaultMessage: 'B2B',
    description: 'business expertise category label',
  },
  b2c: {
    defaultMessage: 'B2C',
    description: 'business expertise category label',
  },
  'business-development': {
    defaultMessage: 'Business Development',
    description: 'business expertise category label',
  },
  'business-strategy': {
    defaultMessage: 'Business Strategy',
    description: 'business expertise category label',
  },
  'co-sell-with-microsoft': {
    defaultMessage: 'Co-sell with Microsoft',
    description: 'business expertise category label',
  },
  'customer-success': {
    defaultMessage: 'Customer Success',
    description: 'business expertise category label',
  },
  design: {
    defaultMessage: 'Design',
    description: 'business expertise category label',
  },
  'diversity-inclusion': {
    defaultMessage: 'Diversity & Inclusion',
    description: 'business expertise category label',
  },
  'funding-investment': {
    defaultMessage: 'Funding & Investment',
    description: 'business expertise category label',
  },
  'hr-hiring': {
    defaultMessage: 'HR & Hiring',
    description: 'business expertise category label',
  },
  leadership: {
    defaultMessage: 'Leadership',
    description: 'business expertise category label',
  },
  legal: {
    defaultMessage: 'Legal',
    description: 'business expertise category label',
  },
  marketing: {
    defaultMessage: 'Marketing',
    description: 'business expertise category label',
  },
  'navigating-microsoft': {
    defaultMessage: 'Navigating Microsoft',
    description: 'business expertise category label',
  },
  partnerships: {
    defaultMessage: 'Partnerships',
    description: 'business expertise category label',
  },
  pitching: {
    defaultMessage: 'Pitching',
    description: 'business expertise category label',
  },
  'product-management': {
    defaultMessage: 'Product Management',
    description: 'business expertise category label',
  },
  research: {
    defaultMessage: 'Research',
    description: 'business expertise category label',
  },
  sales: {
    defaultMessage: 'Sales',
    description: 'business expertise category label',
  },
});
